document.documentElement.classList.remove('no-js');

/* Quantity steppers */
document.addEventListener('click', function (event) {
  var minus = event.target.closest('[data-quantity-minus]');
  var plus = event.target.closest('[data-quantity-plus]');
  if (!minus && !plus) return;
  var control = event.target.closest('.quantity-control');
  var input = control && control.querySelector('input[name="quantity"]');
  if (!input) return;
  var current = Math.max(1, parseInt(input.value || '1', 10));
  input.value = String(minus ? Math.max(1, current - 1) : current + 1);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Sticky header state */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  function onScroll() {
    if (window.scrollY > 24) { header.classList.add('is-stuck'); }
    else { header.classList.remove('is-stuck'); }
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* Scroll reveal */
(function () {
  var items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reduced) {
    for (var i = 0; i < items.length; i++) { items[i].classList.add('is-revealed'); }
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  for (var j = 0; j < items.length; j++) { io.observe(items[j]); }
})();
